import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILicenseManagementState } from "./types";
import { getLicenseTiers, getPackageNames, getLicenseSettings, getSupportedFileFormats } from "./thunks";

const initialState: ILicenseManagementState = {
  isModalOpen: false,
  currentTenantId: null,
  isLoading: false,
  packageNames: [],
  packageInfos: [],
  licenseSettings: [],
  tierOptions: [],
  supportedFileFormats: null,
};

export const licenseManagementSlice = createSlice({
  name: "licenseManagement",
  initialState,
  reducers: {
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setCurrentTenantId: (state, action: PayloadAction<number | null>) => {
      state.currentTenantId = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLicenseTiers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLicenseTiers.fulfilled, (state, action) => {
        state.tierOptions = action.payload;
        state.isLoading = false;
      })
      .addCase(getLicenseTiers.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getPackageNames.fulfilled, (state, action) => {
        state.packageInfos = action.payload;
        // Extract product edition names (name field contains the product edition from LicConstants)
        // Filter out Experimental and QA packages
        state.packageNames = action.payload
          .map(p => p.name)
          .filter(name => name && 
            !name.includes("Experimental") && 
            !name.includes("QA") &&
            !name.includes("Unlicensed") &&
            !name.includes("Unactivated"));
      })
      .addCase(getLicenseSettings.fulfilled, (state, action) => {
        state.licenseSettings = action.payload;
      })
      .addCase(getSupportedFileFormats.fulfilled, (state, action) => {
        state.supportedFileFormats = action.payload;
      });
  },
});

export const { setIsModalOpen, setCurrentTenantId, setLoading } =
  licenseManagementSlice.actions;
export default licenseManagementSlice.reducer;

